import { render, staticRenderFns } from "./TempoProcessamentoPlantao.vue?vue&type=template&id=9d4210dc&scoped=true&"
import script from "./TempoProcessamentoPlantao.vue?vue&type=script&lang=js&"
export * from "./TempoProcessamentoPlantao.vue?vue&type=script&lang=js&"
import style0 from "./TempoProcessamentoPlantao.vue?vue&type=style&index=0&id=9d4210dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4210dc",
  null
  
)

export default component.exports